<template>
  <div class="container">
    <el-container>
      <el-header v-if="pc == 1">
        <div class="logo" @click="backHome">
          <!-- <icon name="LOGO"></icon> -->
          <img src="../../assets/images/kailei_logo.png" />
          <span>Kerry Cloud</span>
        </div>
        <el-menu
          :default-active="activeRouter"
          router
          mode="horizontal"
          background-color="transparent"
          text-color="#fff"
          active-text-color="#fff"
        >
          <el-menu-item index="/home">
            <i class="el-icon-sy"></i>
            <span slot="title">{{ $t("home") }}</span>
          </el-menu-item>
          <el-menu-item index="/projectScene">
            <i class="el-icon-xmxc"></i>
            <span slot="title">{{ $t("ProjectSite") }}</span>
          </el-menu-item>
          <el-menu-item index="/map">
            <i class="el-icon-dt"></i>
            <span slot="title">地图</span>
          </el-menu-item>
          <el-menu-item index="/notice">
            <i class="el-icon-gj"></i>
            <span slot="title">告警</span>
            <el-badge v-if="count != 0" :value="count" class="item"> </el-badge>
          </el-menu-item>
          <el-menu-item index="/log">
            <i class="el-icon-rz"></i>
            <span slot="title">日志</span>
          </el-menu-item>
          <el-menu-item v-show="is_admin == 1" index="/template">
            <i class="el-icon-sbmb"></i>
            <span slot="title">组态模板</span>
          </el-menu-item>
          <el-menu-item index="/repair">
            <i class="el-icon-pgwx"></i>
            <span slot="title">派工维修</span>
          </el-menu-item>
          <!-- <el-menu-item index="/userJurisdiction" v-if="create_by_id == '0'">
            <i class="el-icon-yhqx"></i>
            <span slot="title">{{$t('UserRights')}}</span>
          </el-menu-item> -->
        </el-menu>
        <div class="headRight">
          <!-- <div class="Download">
            <el-popover
            placement="bottom"
            trigger="hover">
            <div style="text-align:center;">
              <div class="openvpn">
                <img class="icon" src="@/assets/images/icon2.jpg" />
                <el-link class="mt10 mb10" :underline="false" href="https://inhandnetworks.s3.cn-north-1.amazonaws.com.cn/openvpn-install-win10.exe" target="_self">OpenVPN客户端</el-link>
              </div>
              <div class="openvpn">
                <img class="icon" src="@/assets/images/icon1.jpg" />
                <el-link class="mt10 mb10" :underline="false"  @click="downloadOpenVPNfile" >OpenVPN配置文件</el-link>
              </div>
            </div>
            <el-button type="text" class="text" slot="reference">下载</el-button>
          </el-popover>
          </div> -->
          <div class="xcxqrcode" @click="showQrcode = true">
            <el-popover
              placement="bottom"
              popper-class="popover"
              v-model="showQrcode"
            >
              <div style="display:flex;">
                <div class="wxQrcodes">
                  <div class="images">
                    <img
                      src="../../assets/images/xcxqrcode.jpg"
                      alt
                      class="qrcodes"
                    />
                  </div>
                  <P>微信小程序</P>
                </div>
              </div>
              <img src="../../assets/images/icon_ewm.png" slot="reference" />
            </el-popover>
          </div>
          <div class="userImg m20" @click="showInfo = true">
            <img :src="headImg" />
          </div>
          <div class="dropdown">
            <el-dropdown @command="handleCommand">
              <span>
                {{ username }}
                <i class="el-icon-arrow_up"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">个人资料</el-dropdown-item>
                <el-dropdown-item command="e">旧版平台</el-dropdown-item>
                <el-dropdown-item command="f">信息管理</el-dropdown-item>
                <el-dropdown-item command="d" v-if="create_by_id == '0'"
                  >建议反馈</el-dropdown-item
                >
                <!-- <el-dropdown-item command="b">修改密码</el-dropdown-item> -->
                <el-dropdown-item command="c">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="language">
            <el-dropdown @command="checkoutLanguage">
              <span>
                <img src="../../assets/images/international.png"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="cn">简体中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
      </el-header>
      <el-main :class="pc == 1 ? 'el-main1' : 'el-main2'">
        <router-view @pc="pcInfo" />
      </el-main>
      <!-- <el-footer>
        <p class="footer">© 2021</p>
      </el-footer> -->
    </el-container>
    <!-- <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      @close="updateCancel"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width=".8rem"
        ref="update"
        :rules="findPassword"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            size="small"
            class="yl-input_noIcon"
            placeholder="请输入旧密码"
            show-password
            v-model="form.oldPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            size="small"
            class="yl-input_noIcon"
            placeholder="请输入新密码"
            show-password
            v-model="form.password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            size="small"
            class="yl-input_noIcon"
            placeholder="请确认密码"
            show-password
            v-model="form.confirmPassword"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="updatePassword"
          class="yl-button"
          size="mini"
          >确 定</el-button
        >
        <el-button @click="updateCancel" class="yl-button2" size="mini"
          >取 消</el-button
        >
      </span>
    </el-dialog> -->
    <el-dialog
      title="个人资料"
      :visible.sync="showInfo"
      @close="showInfoClose"
      width="40%"
    >
      <div class="userInfo">
        <div class="upload">
          <img :src="headImg" class="uploadImg" />
          <!-- <el-upload
            class="w-158"
            ref="upload"
            :multiple="false"
            :action="actionUrl"
            :headers="uploadHeaders"
            :on-success="uploadSuccess"
            :show-file-list="false"
          >
            <el-button type="primary" class="upload_button">上传头像</el-button>
          </el-upload> -->
        </div>
        <div class="info">
          <div class="info_head">
            <h1>Hello,{{ username }}</h1>
            <!-- <el-button type="primary" size="mini" class="yl-button" @click="Edit">修改资料</el-button> -->
          </div>
          <el-form
            :model="userInfo_form"
            label-position="right"
            label-width=".8rem"
            ref="userInfo_form"
          >
            <el-form-item label="用户名:" prop="username">
              <el-input
                type="text"
                :readonly="readonly"
                v-model="userInfo_form.username"
                class="readonly yl-input_noIcon"
                ref="readonly1"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="phone">
              <el-input
                type="text"
                :readonly="readonly"
                v-model="userInfo_form.phone"
                class="readonly yl-input_noIcon"
                ref="readonly3"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属公司:" prop="companyname">
              <el-input
                type="text"
                :readonly="readonly"
                v-model="userInfo_form.companyname"
                class="readonly yl-input_noIcon"
                ref="readonly4"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址:" prop="email">
              <el-input
                type="text"
                :readonly="true"
                v-model="userInfo_form.address"
                class="readonly yl-input_noIcon"
                ref="readonly2"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="info_footer" v-if="showfooter == true">
            <el-button type="primary" @click="storage('1')" class="yl-button"
              >保存</el-button
            >
            <el-button type="primary" @click="storage('2')" class="yl-button2"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "@/api/data";
import LoginService from "@/api/login";
import axios from "axios";
import { utils } from "@/utils/index.js";
export default {
  data() {
    // const valiConfirmPassword = (rule, value, callback) => {
    //   if (this.form.confirmPassword == "") {
    //     callback(new Error("请确认密码"));
    //   } else if (this.form.confirmPassword != this.form.password) {
    //     callback(new Error("两次密码填写不同"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      is_admin: 0,
      timer: "", //定时器
      pc: 1,
      create_by_id: "", //判断是否为管理员 0代表管理员
      username: sessionStorage.getItem("real_name"),
      count: 0,
      readonly: true,
      lang: "",
      // dialogVisible: false,
      showInfo: false,
      showfooter: false,
      // form: {
      //   oldPassword: "",
      //   password: "",
      //   confirmPassword: "",
      // },
      userInfo_form: {
        username: sessionStorage.getItem("real_name"),
        address: sessionStorage.getItem("address"),
        phone: sessionStorage.getItem("mobile"),
        companyname: sessionStorage.getItem("company"),
      },
      uploadImg: "",
      // findPassword: {
      //   oldPassword: [
      //     { required: true, message: "请输入旧密码", trigger: "blur" },
      //   ],
      //   password: [
      //     { required: true, message: "请输入新密码", trigger: "blur" },
      //   ],
      //   confirmPassword: [
      //     { required: true, validator: valiConfirmPassword, trigger: "blur" },
      //   ],
      // },
    };
  },
  computed: {
    headImg() {
      return this.uploadImg == ""
        ? require("../../assets/images/default.jpg")
        : this.uploadImg;
    },
    activeRouter() {
      return this.$route.path;
    },
    actionUrl() {
      return process.env.NODE_ENV === "development"
        ? "/admin/excel/entry"
        : process.env.BASE_URL + "excel/entry";
    },
    uploadHeaders() {
      return {
        Authorization: this.$store.state.token,
      };
    },
    downUrl() {
      return process.env.NODE_ENV === "development"
        ? "api/user/DownloadOpenVpnConfigurationFile"
        : "/user/DownloadOpenVpnConfigurationFile";
    },
  },
  methods: {
    pcInfo(val) {
      console.log(val);
      if (val == 0) {
        this.pc = val;
      } else {
        this.pc = 1;
        this.getUserInfo();
      }
    },
    handleCommand(e) {
      if (e == "a") {
        this.showInfo = true;
      } else if (e == "b") {
        // this.dialogVisible = true;
      } else if (e == "c") {
        // LoginService.logout({
        //   user_id: this.$store.state.user_id,
        //   token: this.$store.state.token,
        // })
        //   .then((res) => {
        this.$store.dispatch("setToken", "");
        //     this.$router.push("/login");
        //   })
        //   .catch((err) => {
        //     this.$message.error(err.massage);
        //   });
        window.open("https://kac.51kerry.cn/index", "_self");
      } else if (e == "d") {
        this.$router.push("/feedback");
      } else if (e == "e") {
        window.open("https://www.ikaishan.top/", "_blank");
      } else if (e == "f") {
        window.open("https://kac.51kerry.cn/index_admin", "_blank");
      }
    },
    //切换中英文
    checkoutLanguage(e) {
      if (e == "cn") {
        this.lang = "cn";
        this.$i18n.locale = this.lang; //关键语句
        window.sessionStorage.setItem("lang", this.lang);
      } else if (e == "en") {
        this.lang = "en";
        this.$i18n.locale = this.lang; //关键语句
        window.sessionStorage.setItem("lang", this.lang);
      }
    },
    uploadSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    //取消修改密码
    // updateCancel() {
    //   this.dialogVisible = false;
    //   this.$refs.update.resetFields();
    // },
    //修改密码
    // updatePassword() {
    //   this.$refs.update.validate((vaild) => {
    //     if (vaild) {
    //       DataService.updatePassword({
    //         user_id: this.$store.state.user_id,
    //         password: this.$Base64.encode(this.form.password),
    //         oldPassword: this.$Base64.encode(this.form.oldPassword),
    //         confirmPassword: this.$Base64.encode(this.form.confirmPassword),
    //         user_token: this.$store.state.token,
    //         username: this.$store.state.username,
    //       })
    //         .then((res) => {
    //           this.dialogVisible = false;
    //           this.$message.success("修改成功");
    //         })
    //         .catch((err) => {
    //           this.$message.error(err.message);
    //         });
    //     } else {
    //       this.$message.error("请检查必填项");
    //       return false;
    //     }
    //   });
    // },
    Edit() {
      console.log(this.$refs.readonly1.$el.style);
      this.$refs.readonly1.$el.style.border = "1px solid #01A6FF";
      // this.$refs.readonly2.$el.style.border="1px solid #e6e6e6";
      this.$refs.readonly3.$el.style.border = "1px solid #01A6FF";
      this.$refs.readonly4.$el.style.border = "1px solid #01A6FF";
      this.$refs.readonly1.$el.style.borderRadius = "5px";
      this.$refs.readonly3.$el.style.borderRadius = "5px";
      this.$refs.readonly4.$el.style.borderRadius = "5px";
      this.readonly = false;
      this.showfooter = true;
    },
    storage(e) {
      this.$refs.readonly1.$el.style.border = "none";
      // this.$refs.readonly2.$el.style.border="none";
      this.$refs.readonly3.$el.style.border = "none";
      this.$refs.readonly4.$el.style.border = "none";
      this.readonly = true;
      this.showfooter = false;
      e == "1" ? this.submit() : this.cancel();
    },
    //提交修改个人资料
    submit() {
      DataService.editUserInfo({
        phone: this.userInfo_form.phone,
        user_realname: this.userInfo_form.username,
        company_name: this.userInfo_form.companyname,
        user_id: this.$store.state.user_id,
      })
        .then((res) => {
          this.$message.success("修改成功");
          this.getUserInfo();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //取消修改个人资料
    cancel() {
      this.$refs["userInfo_form"].resetFields();
    },
    //关闭修改个人资料弹窗
    showInfoClose() {
      this.$refs.readonly1.$el.style.border = "none";
      // this.$refs.readonly2.$el.style.border="none";
      this.$refs.readonly3.$el.style.border = "none";
      this.$refs.readonly4.$el.style.border = "none";
      this.readonly = true;
      this.showfooter = false;
    },
    //点击LOGO
    backHome() {
      this.$router.push("/home");
    },
    //获取用户个人资料
    getUserInfo() {
      DataService.getUserInfo({
        user_id: this.$store.state.user_id,
      })
        .then((res) => {
          this.userInfo_form.username = res.data.user_realname;
          this.userInfo_form.companyname = res.data.company_name;
          this.userInfo_form.phone = res.data.phone;
          this.userInfo_form.email = res.data.username;
          this.username = res.data.user_realname;
          this.create_by_id = res.data.create_by_id;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //获取全部告警数据
    getAlarmData() {
      DataService.getAlarmDataAll({
        user_id: this.$store.state.user_id,
        status: 1,
        page: 1,
        size: 10,
        startTime: utils.formatDate(
          new Date(new Date(new Date().toLocaleDateString()).getTime())
        ),
        endTime: utils.formatDate(
          new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 3600 * 1000
          )
        ),
        user_token: this.$store.state.token,
      })
        .then((res) => {
          this.count = res.data.count;
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    //下载OpenVPN配置文件
    downloadOpenVPNfile() {
      window.location.href =
        process.env.NODE_ENV === "development"
          ? `api/user/DownloadOpenVpnConfigurationFile?user_id=${this.$store.state.user_id}`
          : `${process.env.BASE_URL}/user/DownloadOpenVpnConfigurationFile?user_id=${this.$store.state.user_id}`;
    },
  },
  created() {
    // 移动端
    let _this = this;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("mobi") != -1) {
      // 手机浏览器
      console.log("手机");
      this.pc = 0;
    } else {
      // 非手机浏览器
      console.log("非手机");
      setTimeout(() => {
        if (_this.pc == 1) {
          _this.is_admin = sessionStorage.getItem("is_admin");
          // _this.getUserInfo()
        }
      }, 10);
    }
    if (window.sessionStorage.getItem("lang")) {
      this.$i18n.locale = window.sessionStorage.getItem("lang");
      this.lang = window.sessionStorage.getItem("lang");
    } else {
      this.$i18n.locale = "cn";
      this.lang = "cn";
    }
    this.getAlarmData();
  },
  mounted() {
    let _this = this;
    this.timer = setInterval(function() {
      _this.getAlarmData();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: url("https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22631653358657_.pic_hd.jpg")
    no-repeat;
  background-size: 100% 100%;
}
.el-header {
  height: 80px;
  padding: 0;
  height: 100% !important;
  background: url("../../assets/images/bg_top.png") no-repeat;
  background-size: 100% 100%;
}
// .el-footer{
//   background-color: #0A1540;
//   padding: 0;
//   height: 100%!important;
//   .footer{
//     color: #fff;
//     line-height: 34px;
//     margin-left: 20px;
//   }
// }
.el-main1 {
  height: calc(100vh - 80px);
  padding: 0;
}
.el-main2 {
  height: 100vh;
  padding: 0;
}
.logo {
  width: 300px;
  height: 80px;
  text-align: center;
  float: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 30px;
  img {
    width: 80px;
    height: 60px;
  }
  span {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    margin-left: 10px;
    color: #fff;
  }
}
.el-menu {
  width: calc(100vw - 650px);
  border: none;
  float: left;
  height: 80px;
  /deep/span {
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
  }
}
.el-menu--horizontal > .el-menu-item {
  line-height: 0;
  height: 80px;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
}
.el-menu-item [class^="el-icon-"] {
  margin-right: 0;
  margin-bottom: 13px;
}
.el-menu-item:hover {
  background: url("../../assets/images/icon_sel.png") no-repeat !important;
  background-size: 100% 100%;
}
.el-menu--horizontal > .el-menu-item.is-active {
  background: url("../../assets/images/icon_sel.png") no-repeat !important;
  background-size: 100% 100%;
}
.headRight {
  // margin-right: 20px;
  float: right;
  display: flex;
  height: 80px;
  width: 260px;
  align-items: center;
  justify-content: flex-start;
  .Download {
    cursor: pointer;
  }
  .userImg {
    height: 34px;
    width: 34px;
    cursor: pointer;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      vertical-align: middle;
    }
  }
  .dropdown {
    width: 150px;
    .el-dropdown {
      height: 80px;
      margin-left: 10px;
      width: 100%;
      color: #fff;
      cursor: pointer;
      text-align: center;
      /deep/ .el-dropdown-selfdefine {
        background-color: transparent;
        border: none;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        height: 80px;
        line-height: 80px;
      }
    }
  }
  .language {
    width: 26px;
    img {
      width: 100%;
      height: 26px;
      text-align: center;
      cursor: pointer;
      vertical-align: middle;
    }
  }
}
.userInfo {
  padding: 20px;
  display: flex;
  .upload {
    width: 200px;
  }
  .info {
    width: 100%;
    .info_head {
      display: flex;
      margin-bottom: 30px;
      h1 {
        line-height: 24px;
        font-weight: 600;
        font-size: 26px;
        margin-left: 50px;
        color: #fff;
        margin-right: 10px;
      }
    }
    .info_footer {
      margin-left: 40px;
    }
  }
}
.uploadImg {
  width: 150px;
  height: 150px;
  background-size: cover;
}
.upload_button {
  margin-top: 10px;
  margin-left: 26px;
}
.readonly {
  /deep/.el-input__inner {
    border: none;
  }
}
.openvpn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.item {
  position: absolute;
  right: 12px;
  bottom: 28px;
}
.xcxqrcode {
  width: 30px;
  height: 30px;
  .popover {
    width: 160px;
  }
  img {
    width: 100%;
    cursor: pointer;
  }
}
.wxQrcodes {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin:0 10px;
  width: 160px;
  .images {
    width: 120px;
    .qrcodes {
      // margin-left: 6px;
      width: 100%;
    }
  }

  p {
    margin-top: 10px;
    // font-size: 22px;
    // font-weight: 700;
  }
}
</style>
